import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useLingui as _useLingui } from "@lingui/react";
import useLoadingAnnouncer from '../LoadingAnnouncer/useAnnouncer';
const StyledSpinner = styled.svg`
  position: absolute;
  top: calc(50% - ${({
  width
}) => `${parseFloat(width) / 2}rem`});
  left: calc(50% - ${({
  width
}) => `${parseFloat(width) / 2}rem`});
  display: inline-block;
  animation: rotate 1.8s linear infinite;

  & .path {
    stroke: ${({
  theme,
  $color
}) => theme.palette[$color] ?? $color};
    stroke-linecap: round;
    animation: dash 2s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -125;
    }
  }
`;
const Spinner = ({
  active = true,
  color,
  width,
  height,
  ...props
}) => {
  const {
    _: _t
  } = _useLingui();
  useLoadingAnnouncer({
    active
  });
  return /*#__PURE__*/React.createElement(StyledSpinner, _extends({
    viewBox: "0 0 50 50",
    role: "img",
    "aria-label": _t(
    /*i18n*/
    {
      id: "M2XyOJ",
      message: "Loading animation"
    }),
    $color: color
  }, props, {
    width,
    height
  }), /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "4"
  }));
};
Spinner.propTypes = {
  // eslint-disable-next-line @upgrade/no-color-literals
  color: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
};
export default Spinner;
//# sourceMappingURL=index.js.map